module.exports = __webpack_public_path__ + "img/流体力学1_4.6197f93f.jpg";